<template>
    <div class="w-full  flex items-center justify-center">
        <component :is="steps[step - 1].component"
                   :active_application="active_application"
                   :active_job="active_job"
                   :selected_choice="selected_choice"
                   :selected_flow="selected_flow"
                   class="w-full"
                   @next="nextStep($event)"
                   @previous="$event ? step = $event : step--"
                   @setApplication="setApplication"
                   @setChoice="setChoice"
                   @setFlow="setFlow"
                   @setJob="setJob"
        />
    </div>
</template>

<script>
import Welcome from '../components/ui/free-trial/Welcome.vue';
import SelectStep from '../components/ui/free-trial/SelectStep.vue';
import FinalStep from '../components/ui/free-trial/FinalStep.vue';
import BrandingInfo from '../components/ui/free-trial/BrandingInfo.vue';
import JobsiteHeader from '../components/ui/free-trial/JobsiteHeader.vue';
import Vacancy from '../components/ui/free-trial/Vacancy.vue';
import VacancyProcess from '../components/ui/free-trial/VacancyProcess.vue';
import ApplicantDetail from '../components/ui/free-trial/ApplicantDetail.vue';
import VacancyShare from '../components/ui/free-trial/VacancyShare.vue';
import {mapState, mapActions} from 'pinia';
import {useMainStore} from '../state/store';
import {trackFreeTrialView} from '../etc/trackers';

export default {
    name: 'FreeTrial',
    components: {SelectStep, Welcome, BrandingInfo, JobsiteHeader, FinalStep, Vacancy, VacancyProcess, ApplicantDetail, VacancyShare},
    data() {
        return {
            step: 1,
            // Step 2
            selected_choice: null,
            // Step 3
            selected_final_step: null,
            // Step 6 - job
            active_job: null,
            // Step 7 - applicant
            active_application: null,
            // Step 8 - share job
            selected_flow: null,
        };
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        steps() {
            return [
                {component: 'welcome', menuItems: null},
                {component: 'select-step', menuItems: null},
                {component: 'final-step', menuItems: null},
                {component: 'branding-info', menuItems: {'branding': true}},
                {component: 'jobsite-header', menuItems: {'branding': true}},
                {component: 'vacancy', menuItems: {'branding': false, 'jobs': true}},
                {component: 'vacancy-process', menuItems: {'branding': false, 'jobs': true}},
                {component: 'applicant-detail', menuItems: {'branding': false, 'jobs': false, 'applications': true}},
                {component: 'vacancy-share', menuItems: {'branding': false, 'jobs': true, 'applications': false}},
            ];
        },
    },
    methods: {
        ...mapActions(useMainStore, ['setOverrideMenuItems']),
        setChoice(choice) {
            this.selected_choice = choice;
        },
        setJob(job) {
            this.active_job = job;
        },
        setApplication(application) {
            this.active_application = application;
        },
        setFlow(flow) {
            this.selected_flow = flow;
        },
        nextStep(value) {
            value ? this.step = value : this.step++;

            //Track the client step
            this.trackStep(this.step);

            //Override menu items
            this.setOverrideMenuItems(this.steps[this.step - 1].menuItems);
        },
        trackStep(step){
            trackFreeTrialView(step);
        }
    },
    mounted() {
        if (!this.currentCompany.in_setup) {
            return this.$router.push('/');
        }

        this.trackStep(1);
    },
};
</script>
